import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SUBMIT_BUTTON_CLASS_NAME = 'SubmitButton';
export const SUBMIT_BUTTON_CLASS_SLOTS = [
	'root',
	'button',
	'progress',
] as const;

export type SubmitButtonClassSlot = (typeof SUBMIT_BUTTON_CLASS_SLOTS)[number];

export interface SubmitButtonClasses {
	root: string;
	button: string;
	progress: string;
	fullWidth: string;
	iconOnly: string;
	submitting: string;
}

export type SubmitButtonClassKey = keyof SubmitButtonClasses;

export const getSubmitButtonUtilityClass = (slot: string) =>
	generateUtilityClass(SUBMIT_BUTTON_CLASS_NAME, slot);

export const submitButtonClasses: SubmitButtonClasses = generateUtilityClasses(
	SUBMIT_BUTTON_CLASS_NAME,
	['root', 'button', 'progress', 'fullWidth', 'iconOnly', 'submitting'],
);

export default submitButtonClasses;
